/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';
import type { NavigationView } from './NavigationView.types.tsx';

export const cloneView = (
	viewId: string,
	params: {
		viewType: 'LIST' | 'TIMELINE' | 'BOARD' | 'MATRIX' | 'SECTION' | 'TREE';
		name: string;
		emoji?: string;
	},
): Promise<NavigationView> =>
	performPostRequest(`${getJpdViewsServicePathPrefix()}/v1/views/${viewId}/clone`, {
		body: JSON.stringify(params),
	});
